import React from 'react';
import { NavBar } from '../components/ui/NavBar';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { AuthoritySection } from '../components/sections/AuthoritySection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { DifferentiationSection } from '../components/sections/DifferentiationSection';
import { CaseStudiesSection } from '../components/sections/CaseStudiesSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-emerald-100 selection:text-emerald-900" data-id="element-186">
      <NavBar data-id="element-187" />
      <main data-id="element-188">
        <HeroSection data-id="element-189" />
        <ProblemSection data-id="element-190" />
        <AuthoritySection data-id="element-191" />
        <ServicesSection data-id="element-192" />
        <DifferentiationSection data-id="element-193" />
        <CaseStudiesSection data-id="element-194" />
        <FinalCTASection data-id="element-195" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-196">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-197">
          <div className="mb-4 md:mb-0" data-id="element-198">
            <span className="text-xl font-bold" data-id="element-199">
              <span style={{
              color: '#ffffff'
            }} data-id="element-200">
                Pen
              </span>
              <span style={{
              color: '#059669'
            }} data-id="element-201">
                Point
              </span>
              
            </span>
          </div>
          <div className="text-sm" data-id="element-202">
            &copy; {new Date().getFullYear()} All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}